import React from "react";

const AssessmentSkeleton = () => {
  return (
    <div className="w-full mx-auto mb-5">
      {/* Header Skeleton */}
      <div className="mt-3 mb-2">
        <div className="w-[40%] h-8 bg-gray-200 rounded-md mb-2" />
      </div>

      {/* Image Banner Skeleton */}
      <div className="w-full h-[230px] bg-gray-200 rounded-lg mb-3" />

      {/* Tabs Skeleton */}
      <div className="w-[92%] mx-auto mb-3">
        <div className="flex items-center gap-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-10 bg-gray-200 rounded-md
                   w-[90px] sm:w-[120px] md:w-[140px]"
            />
          ))}
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="w-[92%] mx-auto">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-[120px] bg-gray-200 rounded-md" />
          ))}
        </div>

        {/* Main Content Area */}
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-6">
          <div>
            <div className="h-[200px] bg-gray-200 rounded-lg mb-4" />
            <div className="h-[300px] bg-gray-200 rounded-lg" />
          </div>

          <div className="h-[400px] bg-gray-200 rounded-lg" />
        </div>
      </div>
    </div>
  );
};

export default AssessmentSkeleton;
